import {PREVIEW_IMAGE_PLACEHOLDER_SRC} from '../../../../review-preview-video';

type ImageItemType = {src: string | null; alt: string | null} | HTMLImageElement;

type GalleryImageMediaItemType = {
    type: 'image';
    key: string;
    src: string;
    alt: string | null;
};

type GalleryVideoMediaItemType = {
    type: 'video';
    key: string;
    src: string;
    poster: string | null;
    previewSrc: string;
};

type GalleryMediaItemType = GalleryImageMediaItemType | GalleryVideoMediaItemType;

function getImageSrc(image: ImageItemType): string | null {
    return image.src || null;
}

function getImageAlt(image: ImageItemType): string | null {
    if ('alt' in image && typeof image.alt === 'string') {
        return image.alt;
    }

    return null;
}

export function buildGalleryMediaItems(
    images?: Array<ImageItemType>,
    videos?: Array<{src: string | null; poster: string | null}>
): Array<GalleryMediaItemType> {
    const imageItems: Array<GalleryImageMediaItemType> =
        images?.flatMap((image) => {
            const src = getImageSrc(image);

            if (!src) {
                return [];
            }

            return [
                {
                    type: 'image',
                    key: src,
                    src,
                    alt: getImageAlt(image),
                },
            ];
        }) ?? [];

    const videoItems: Array<GalleryVideoMediaItemType> =
        videos?.flatMap((video) => {
            if (!video.src) {
                return [];
            }

            return [
                {
                    type: 'video',
                    key: video.src,
                    src: video.src,
                    poster: video.poster,
                    previewSrc: video.poster || PREVIEW_IMAGE_PLACEHOLDER_SRC,
                },
            ];
        }) ?? [];

    return [...imageItems, ...videoItems];
}

export function isGalleryVideoMediaItem(item: GalleryMediaItemType | undefined): item is GalleryVideoMediaItemType {
    return item?.type === 'video';
}
